// TODO: repasser à un traitement différent par page
import { AuctionLightDTO } from 'models'

const generateAuctionsTableTitleFromLight = (
  auctionLight: AuctionLightDTO,
  fallbackNo?: string,
) => {
  const date = auctionLight.auctionDate ? auctionLight.auctionDate.replace('T', ' à ') : ''
  if (auctionLight.isOnlineAuction && date) {
    return `Vente en ligne du ${date}`
  }
  if (auctionLight.description && date) {
    return ` ${auctionLight.description}, le ${date}`
  }
  if (date) {
    return `Vente du ${date}`
  }
  if (fallbackNo) {
    return `Vente ${fallbackNo}`
  }
  return 'Vente'
}

export { generateAuctionsTableTitleFromLight }
